import { Task } from '@admiin-com/ds-graphql';
import { WBFlex, WBLink, WBTypography } from '@admiin-com/ds-web';
import { LoadSvgIcon } from '../../../../component/LoadSvgIcon/LoadSvgIcon';
import File from '../../../../../assets/icons/file-white.svg';
import { LineItemsView } from './LineItemsView';
import {
  frontDateFromBackendDate,
  numberToCurrency,
} from '@admiin-com/ds-common';
import { Divider } from '@mui/material';
import { t } from 'i18next';
import { useModal } from '../../ModalManager/ModalContext';
import { useTaskToContactName } from '../../../../hooks/useTaskToName/useTaskToName';
export const TaskDetailCard = ({ task }: { task: Task }) => {
  const { openModal } = useModal();
  const { name } = useTaskToContactName(task);

  return (
    <WBFlex
      flexDirection={'column'}
      sx={{ background: 'background.paper', padding: 1 }}
      gap={1}
    >
      <WBTypography fontWeight="bold">{name}</WBTypography>
      <WBFlex flexDirection={'row'} alignItems={'center'} gap={1}>
        <LoadSvgIcon component={File} width={25} height={25} />
        <WBTypography>
          {task.futureLinkedTask?.reference ?? task.reference}
        </WBTypography>
      </WBFlex>
      <WBFlex
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        gap={2}
      >
        <WBTypography variant="body2" color="textSecondary">
          {frontDateFromBackendDate(task.futureLinkedTask?.dueAt ?? task.dueAt)}
        </WBTypography>
        <WBLink
          variant="body2"
          onClick={(e) => {
            e.preventDefault();
            openModal('viewDocument', {
              task,
            });
          }}
        >
          {t('viewDocument', { ns: 'taskbox' })}
        </WBLink>
      </WBFlex>
      <LineItemsView task={task} />
      <Divider />
      <WBFlex
        flexDirection={'row'}
        justifyContent={'end'}
        alignItems={'center'}
      >
        <WBTypography variant="h5">
          {`${numberToCurrency(
            (task.futureLinkedTask?.amount ?? task.amount ?? 0) / 100
          )}`}
        </WBTypography>
      </WBFlex>
    </WBFlex>
  );
};
